export default {
  WEBSITE: 'http://10.1.196.2',
  WEBSITEINTL: 'http://10.1.196.2:9080',
  APIHOST: 'https://mobvoi-mw-test.weta365.com/cwhCopilot',
  AVATARURL: 'ws://101.35.238.186:9041/websocket/avatar'
}
